import { Schema } from "effect";
export const UserType = Schema.Literal("talent", "recruiter");
export const TeamsCallVerbosity = Schema.Literal("off", "verbose", "info", "warning", "error");
export const FeatureFlag = Schema.Struct({
    id: Schema.String,
    name: Schema.String,
    description: Schema.optional(Schema.String),
    enabled: Schema.Boolean,
    category: Schema.optional(Schema.String),
    createdAt: Schema.Date,
    updatedAt: Schema.Date,
});
